<template>
    <tr class="workflows__log_table_item">
        <td class="workflows__log_table_item_name">{{ workflowName }}</td>
        <td class="workflows__log_table_item_createdat">
            {{ workflowCreatedAtDate }}
            <component-text :size="'tiny'">
                Time: {{ workflowCreatedAtTime }}
            </component-text>
        </td>
        <td class="workflows__log_table_item_trigger">{{ workflowTrigger }}</td>
        <td class="workflows__log_table_item_enrolto">{{ workflowEnrolTo }}</td>
        <td class="workflows__log_table_item_result">
            <component-status :status="workflowResult"></component-status>
        </td>
        <td class="workflows__log_table_item_actions">
            <div class="columns">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :name="`lms-superadmin-users-profile-edit-learning-history-table-item-collapse`"
                        :icon="true"
                        :icon-name="collapseActive ? 'chevron-up' : 'chevron-down'"
                        :theme="'default'"
                        @click="performEmit('emit-collapse', index)"
                    />
                </div>
            </div>
        </td>
    </tr>
</template>

<script>

import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentText from '@/components/default/shared/ComponentText'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'

export default {
  name: 'lms-superadmin-workflows-log-orgunits-table-item',
  components: { ComponentText, ComponentStatus, ComponentButton },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    workflowName () {
      return this.item.workflowName
    },
    workflowId () {
      return this.item.workflowId
    },
    workflowCreatedAtDate () {
      return this.item.created_at ? toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.created_at)) : '-'
    },
    workflowCreatedAtTime () {
      return this.item.created_at ? toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.created_at)) : '-'
    },
    workflowTrigger () {
      return this.item.workflowTriggerName
    },
    workflowEnrolTo () {
      return this.item.catalogItemName
    },
    workflowResult () {
      return this.item.result ? 'success' : 'fail'
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/workflows/_workflowslogtableitem.scss";
</style>
